module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-13.aaf4e0b7.png";